import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import _ from 'lodash';
import axios from 'axios';
import {csv} from 'd3-fetch';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';

import Nouislider from "nouislider-react";
import "nouislider/dist/nouislider.css";

import moment from 'moment';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCalendarDay, faGrinTongueSquint } from '@fortawesome/free-solid-svg-icons';

import { JoyChart } from './components/JoyChart';
import { CountrySelect } from './components/CountrySelect';

import './app.scss';
import { select } from 'd3';

import * as events from './data/events.json';


export class App extends React.Component {
    
    constructor(){
        super();
        this.state = {
            api: {
                baseUrl: 'https://ckan.africadatahub.org/api/3/',
                countryData: '15b5b9eb-e68e-461c-8f8e-7bd0c69dcd14' 
            },

            loading: true,
            loadingText: 'Loading...',

            dates: [],
            dateRange: [],
            startDate: null,
            endDate: null,

            regions: [],
            countries: [],
            selectedCountries: [],
            countriesSelectBox: [],

            indicators: [],
            selectedMetric: 'PCPIF_PC_CP_A_PT',

            data: [],
            currentData: []
        }
    }

    componentDidMount() {





        console.log('Loading African regions list...');
        this.setState({ loadingText: 'Loading African regions list...' });

        Promise.all([
            csv("./regions.csv"),
            csv("./indicators.csv")
        ]).then((files) => {

            // REGIONS
            // Load the regions CSV and populate the countries dropdown

            let regions = files[0];

            let regionsList = regions.map((region) => {
                return region.region;
            })

            let uniqIds1 = {}, source1 = regionsList;
            regionsList = source1.filter(obj => !uniqIds1[obj] && (uniqIds1[obj] = true));

            let countries = [];

            // Here we order the regions so that North is on top and South at the bottom.

            // We're also adding country counts so that we know how many is in a region and can shade the fills accordingly.

            let region_order = [
                { 
                    region: 'Northern Africa',
                    count: 0 
                }, 
                { 
                    region: 'Eastern Africa',
                    count: 0 
                },
                { 
                    region: 'Central Africa',
                    count: 0 
                },
                { 
                    region: 'Western Africa',
                    count: 0 
                },
                { 
                    region: 'Southern Africa',
                    count: 0 
                }
            ]

            for (let index = 0; index < regions.length; index++) {

                let order = _.findIndex(region_order, region => regions[index].region == region.region);

                region_order[order].count = region_order[order].count + 1;

                countries.push({
                    iso_code: regions[index].iso_code,
                    location: regions[index].country,
                    region: regions[index].region,
                    value: regions[index].iso_code,
                    label: regions[index].country,
                    order: order,
                    regionOrder: region_order[order].count
                })


            }

            countries = _.sortBy(countries, 'order');

            let countriesSelectBox = countries;

            countriesSelectBox = _.orderBy(countriesSelectBox, 'order');

            let region_countries = _.filter(countries, (country) => country.region == 'Northern Africa');

            countriesSelectBox.splice(0, 0, {
                iso_code: region_countries.map(country => country.iso_code),
                location: 'Northern Africa'
            })

            region_countries = _.filter(countries, (country) => country.region == 'Eastern Africa');

            countriesSelectBox.splice(7, 0, {
                iso_code: region_countries.map(country => country.iso_code),
                location: 'Eastern Africa'
            })

            region_countries = _.filter(countries, (country) => country.region == 'Central Africa');

            countriesSelectBox.splice(26, 0, {
                iso_code: region_countries.map(country => country.iso_code),
                location: 'Central Africa'
            })

            region_countries = _.filter(countries, (country) => country.region == 'Western Africa');

            countriesSelectBox.splice(36, 0, {
                iso_code: region_countries.map(country => country.iso_code),
                location: 'Western Africa'
            })

            region_countries = _.filter(countries, (country) => country.region == 'Southern Africa');

            countriesSelectBox.splice(54, 0, {
                iso_code: region_countries.map(country => country.iso_code),
                location: 'Southern Africa'
            })


            // INDICATORS
            // Load the indicators CSV and populate the metric dropdown

            console.log('Loading indicators...');
            let indicators = files[1];

            console.log('Calculating dates...');
            this.setState({ loadingText: 'Calculating dates...' });
            
            // ALL DATES
            // Get all the dates in the complete dataset

            axios.get(this.state.api.baseUrl + 'action/datastore_search_sql?sql=SELECT%20*%20FROM%20"' + this.state.api.countryData + '"',
                { headers: {
                    authorization: process.env.REACT_API_KEY
                }
            })
            .then((response) => {

                let dates = [];
                
                for (let index = 0; index < response.data.result.fields.length; index++) {
                    
                    let id = response.data.result.fields[index].id;
                    
                    if(id != '_id' && id != '_full_text' && id != 'Geography' && id != 'Country' && id != 'Indicator.Name' && id != 'Indicator.Code' && id != 'Attribute') {
                        
                        let date = id.split('-');

                        dates.push(date[0] + '-' + date[1]);
                    }
                }

                // Save the dates for the entire pandemic: dates, startDate, endDate, minDate and maxDate

                this.setState({
                    regions: regionsList,
                    countries: countries,
                    selectedCountries: countries.map((country) => country.iso_code),
                    countriesSelectBox: countriesSelectBox,
                    indicators: indicators,
                    dates: dates,
                    dateRange: dates,
                    startDate: 0,
                    endDate: dates.length - 1
                }, () => this.fetchData())

            })
        
        })

    }

    fetchData = () => {

        let self = this;

        console.log('Fetching data...');
        this.setState({ loadingText: 'Fetching data...' });


        axios.get(this.state.api.baseUrl + 'action/datastore_search_sql?sql=SELECT%20*%20FROM%20"' + this.state.api.countryData + '"',
            { headers: {
                "Authorization": process.env.REACT_API_KEY
                }
        }).then(function(response) {

            console.log('Fetched data...');

            let data = response.data.result.records;

            let allCountries = [];

            self.state.countries.forEach((country) => {
                allCountries.push(country);
            })

            let finalCountriesData = allCountries;

            // Add an empty values array where we will story each day's data.

            finalCountriesData.forEach((country) => {
                country.values = [];
                country.allValues = []; // We added this to keep access to the complete dataset
            })

            console.log('Sorting data...');
            self.setState({ loadingText: 'Sorting data...' });

            // loop through the incoming records and add it to the related country's new values array.


            // Group data by Geography

            let groupedData = _.groupBy(data, 'Geography');

            // loop through object keys

            for (let key in groupedData) {

                let transformedData = [];

                for (let id in groupedData[key][0]) {
                    if(id != '_id' && id != '_full_text' && id != 'Geography' && id != 'Country' && id != 'Indicator.Name' && id != 'Indicator.Code' && id != 'Attribute') {
                        

                        let originalDate = id;

                        let date = id.split('-');
                        

                        let dayData = {
                            date: date[0] + '-' + date[1]
                        }

                        groupedData[key].forEach((indicator) => {
                            
                            dayData[indicator["Indicator.Code"]] = indicator[originalDate] != 'NA' ? indicator[originalDate] : NaN;
                        
                        
                        })

                      
                        transformedData.push(dayData);
                    }
                }

                // sort transformedData by date 

                transformedData = _.sortBy(transformedData, 'date');

                let iso_code = key;

                let related_country_index = _.findIndex(finalCountriesData, o => { 
                    return o.iso_code == iso_code
                });

                if(related_country_index > -1) {
                    finalCountriesData[related_country_index].allValues = transformedData;
                }
            
            
            }


            /* Final data looks like: [
                {
                    iso_code: 'ZAF',
                    location: 'South Africa',
                    region: 'Southern Africa',
                    order: 0,
                    values: [
                        {
                            date: '2020-02-07',
                            new_cases: 20,
                            total_cases: 20
                        }
                    ]
                }
            ] */



            self.setState({
                data: finalCountriesData,
            }, () => self.executeQuery())
        
        })
    
    }

    executeQuery = () => {


        console.log('Flying over landscape...');
        this.setState({ 
            loadingText: 'Flying over landscape...' 
        });

        let filteredData = _.filter(this.state.data, d => this.state.selectedCountries.indexOf(d.iso_code) > -1 );

        filteredData.forEach(country => {
            let filteredValues = _.filter(country.allValues, d => this.state.dateRange.indexOf(d.date) > -1 );
            country.values = filteredValues; 
        })

        this.setState({
            currentData: filteredData,
            loading: false
        });

        


    }

    filterByCountry = (e) => {

        let values = e.target.attributes.value.value.split(',');

        let selectedCountries = this.state.selectedCountries;

        if(values.length > 1) {

            if(values.every(iso_code => selectedCountries.includes(iso_code))) {
                values.forEach((value) => {
                    selectedCountries = _.without(selectedCountries, value);
                })
            } else {
                values.forEach((value) => {
                    if(selectedCountries.indexOf(value) == -1) {
                        selectedCountries.push(value);
                    }
                })
            }


        } else {

            values.forEach((value) => {
                if(selectedCountries.indexOf(value) == -1) {
                    selectedCountries.push(value);
                } else {
                    selectedCountries = _.without(selectedCountries, value);
                }
            })

        }

        this.setState({
            loading: true,
            selectedCountries: selectedCountries,
            }, () => this.executeQuery()
        );
        
    }

    selectMetric = (e) => {

        this.setState({
                loading: true,
                selectedMetric: e.target.value
            }, () => this.executeQuery()
        );
    }

    onSlide = (e) => {

        this.setState({
            startDate: parseInt(e[0]),
            endDate: parseInt(e[1])
        })

    }

    onEnd = (e) => {

        let date_range = _.filter(this.state.dates, (d,i) => { return i >= parseInt(e[0]) && i <= parseInt(e[1]) });

        this.setState({
                loading: true,
                startDate: parseInt(e[0]),
                endDate: parseInt(e[1]),
                dateRange: date_range,
            }, () => this.executeQuery()
        )
    }

    
    
    
    render() {
        return  <>
                <header>
                    <div className="fullsize" style={{maxWidth: '1140px'}}>&nbsp;</div>
                    <Container className="py-4" fluid="lg">
                        { document.URL.indexOf('title') > -1 &&
                            <Row className="mb-4">
                                <Col>
                                    <h2 className="text-center">{new URL(location.href).searchParams.get('title')}</h2>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col xs="auto">
                                <CountrySelect 
                                    countries={this.state.countries}
                                    countriesSelectBox={this.state.countriesSelectBox}
                                    selectedCountries={this.state.selectedCountries}
                                    filterByCountry={this.filterByCountry}
                                />
                            </Col>
                            <Col>
                                <Form.Select className="control-grey" onChange={this.selectMetric} value={this.state.selectedMetric}>
                                    {
                                        this.state.indicators.map(({indicator_name, indicator_code}) => <option key={indicator_code} value={indicator_code}>{indicator_name}</option>)
                                    }
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col className="pe-4">
                                <Nouislider
                                    onSlide={this.onSlide}
                                    onEnd={this.onEnd}
                                    range={{ min: 0, max: this.state.dates.length - 1 }}
                                    step={1}
                                    //behaviour='drag'
                                    start={[ 0, this.state.dates.length - 1 ]}
                                    connect={true}
                                    pips= {{
                                        mode: 'count',
                                        values: 6,
                                        density: 4,
                                        stepped: true
                                    }} />
                            </Col>
                            <Col xs="auto">
                                <h4 className="pt-2">{ moment(this.state.dates[this.state.startDate]).format('MM/YY') } - { moment(this.state.dates[this.state.endDate]).format('MM/YY') }</h4>
                            </Col>
                        </Row>
                        
                    </Container>
                </header>

                <div className={this.state.loading ? 'd-block' : 'd-none'}>
                    <div className="position-absolute top-50 start-50 translate-middle text-center">
                        <Spinner animation="grow" />
                        <h3 className="mt-4">{ this.state.loadingText }</h3>
                        <Container></Container>
                    </div>
                </div>
                <div className={this.state.loading ? 'd-none' : 'd-block'}>
                    <Container className="mt-2" fluid="lg">
                        <Card className="mt-2" id="JoyChartContainer">
                            {this.state.currentData.length > 0 && (
                            <JoyChart 
                                data={ this.state.currentData }
                                countries={ this.state.countries }
                                dates={ this.state.dateRange }
                                selectedMetric= { this.state.selectedMetric }
                            />)}

                        </Card>
                    </Container>
                </div>
            </>
          
    }

}

const container = document.getElementsByClassName('app')[0];
const root = createRoot(container);
root.render(<App />);